import React from "react";
import "./How_We_Work.css";

const How_We_Work = () => {
  return (
    <section className="hww-section">
      <div className="container">

        <h2 className="hww-title">How We Work</h2>

        <div className="row hww-row">
          <div className="col-6 col-sm-6 col-md-3 hww-item">
            <div className="hww-icon-block">
              <img
                src="assets/images/how_we/easy_bookings.png"
                alt="Easy Bookings"
                className="img_holder"
              />
            </div>

            <img
              src="/assets/images/how_we/arrow.png"
              alt="arrow"
              className="hww-arrow"
            />

            <h3 className="hww-heading">Easy Bookings</h3>
            <p className="hww-text">
              Book a cab with ease in just a few simple steps. Fast, reliable,
              and convenient bookings at your fingertips!
            </p>
          </div>
          <div className="col-6 col-sm-6 col-md-3 hww-item">
            <div className="hww-icon-block">
              <img
                src="assets/images/how_we/pickup.png"
                alt="Fastest Pickups"
                className="img_holder"
              />
            </div>

            <img
              src="/assets/images/how_we/arrow.png"
              alt="arrow"
              className="hww-arrow"
            />

            <h3 className="hww-heading">Fastest Pickups</h3>
            <p className="hww-text">
              Experience the fastest pickups for your rental cab. Get on the
              road quickly and efficiently with us!
            </p>
          </div>
          <div className="col-6 col-sm-6 col-md-3 hww-item">
            <div className="hww-icon-block">
              <img
                src="assets/images/how_we/easy_bookings.png"
                alt="Quick Rides"
                className="img_holder"
              />
            </div>

            <img
              src="/assets/images/how_we/arrow.png"
              alt="arrow"
              className="hww-arrow"
            />

            <h3 className="hww-heading">Quick Rides</h3>
            <p className="hww-text">
              Get quick rides with our rental cabs for your convenience. Fast,
              efficient, and reliable transportation when you need it!
            </p>
          </div>

          <div className="col-6 col-sm-6 col-md-3 hww-item">
            <div className="hww-icon-block">
              <img
                src="assets/images/how_we/drivers.png"
                alt="Cleared Drivers"
                className="img_holder"
              />
            </div>

            <h3 className="hww-heading">
              Cleared Drivers Quick Rides
            </h3>
            <p className="hww-text">
              All our rental cab drivers are thoroughly vetted and cleared.
              Trustworthy, professional service for a safe and smooth ride.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default How_We_Work;
